import { type CalendarItem, dayParts } from "@/lib/overview";
import { Box, Text } from "@okshaun/components";
import { CalendarChip } from "./calendar-chip";

interface CalendarGridProps {
  days: string[];
  today: string;
  byDay: Map<string, CalendarItem[]>;
}

function Week({ days, today, byDay }: CalendarGridProps) {
  return (
    <Box display="grid" gridTemplateColumns="[repeat(7, minmax(0, 1fr))]" gap="8">
      {days.map((day) => {
        const { dow, date, weekend } = dayParts(day);
        const isToday = day === today;
        const headColor = isToday ? "text.bold" : weekend ? "text.disabled" : "text.subtle";
        return (
          <Box
            key={day}
            display="flex"
            flexDir="column"
            gap="8"
            minH="[176px]"
            p="10"
            borderRadius="4"
            border="default"
            bg={isToday ? "surface.raised" : "surface"}
          >
            <Box display="flex" gap="6" alignItems="baseline">
              <Text textStyle="mono.xs" color={headColor}>
                {dow}
              </Text>
              <Text textStyle="mono.md" color={headColor} fontWeight="medium">
                {date}
              </Text>
              {isToday && (
                <Text textStyle="mono.xs" color="text.accent.purple.bold">
                  today
                </Text>
              )}
            </Box>
            <Box display="flex" flexDir="column" gap="4">
              {(byDay.get(day) ?? []).map((item) => (
                <CalendarChip key={item.id} item={item} />
              ))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export function CalendarGrid({ days, today, byDay }: CalendarGridProps) {
  return (
    <Box display="flex" flexDir="column" gap="8">
      <Week days={days.slice(0, 7)} today={today} byDay={byDay} />
      <Week days={days.slice(7)} today={today} byDay={byDay} />
    </Box>
  );
}
